module.exports = "<mat-icon (click)=\"manageCategories()\" matTooltip=\"Manage Categories\">folder</mat-icon>\r\n"